import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAdminEditWorkspacePage } from '@Organizations/Workspaces/pages-core'
    import '@common/Components/ValidationError.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminEditWorkspacePage',
  setup(__props) {

    const id = useRoute().params.id

    const name = ref()
    const description = ref()
    const startupUrl = ref()

    const { useWorkspaceDetailsQuery, useUpdateWorkspaceCommand, useDeleteWorkspaceCommand } = useAdminEditWorkspacePage()

    const { modelWorkspaceDetailsQueryV1, runWorkspaceDetailsQueryV1 } = useWorkspaceDetailsQuery(id)
    const { invokeUpdateWorkspaceCommandV1, succeedUpdateWorkspaceCommandV1, invoking, validationErrors } = useUpdateWorkspaceCommand(id, name, description, startupUrl)
    const { invokeDeleteWorkspaceCommandV1, succeedDeleteWorkspaceCommandV1 } = useDeleteWorkspaceCommand(id)

    const tid = computed(() => modelWorkspaceDetailsQueryV1.value?.OrganizationUnitId)
    const originalName = computed(() => modelWorkspaceDetailsQueryV1.value?.Name)

    function handleDeleteWorkspaceCommandV1() {
        if (confirm(`Do you want to delete '${originalName.value}' workspace?`)) {
            invokeDeleteWorkspaceCommandV1()
        }
    }

    onMounted(() => {
        runWorkspaceDetailsQueryV1()
    })

    watch(modelWorkspaceDetailsQueryV1, () => {
        name.value = modelWorkspaceDetailsQueryV1.value?.Name
        description.value = modelWorkspaceDetailsQueryV1.value?.Description
        startupUrl.value = modelWorkspaceDetailsQueryV1.value?.StartupUrl
    })

    watch(name, () => {
        document.title = name.value
    })

    watch(succeedUpdateWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/manage/${id}`
        }
    })

    watch(succeedDeleteWorkspaceCommandV1, succeed => {
        if (succeed) {
            location.href = `/#/admin/organizations/workspaces/${tid.value}`
        }
    })

return { __sfc: true,id, name, description, startupUrl, useWorkspaceDetailsQuery, useUpdateWorkspaceCommand, useDeleteWorkspaceCommand, modelWorkspaceDetailsQueryV1, runWorkspaceDetailsQueryV1, invokeUpdateWorkspaceCommandV1, succeedUpdateWorkspaceCommandV1, invoking, validationErrors, invokeDeleteWorkspaceCommandV1, succeedDeleteWorkspaceCommandV1, tid, originalName, handleDeleteWorkspaceCommandV1 }
}

})